<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper" ></font-awesome-icon>
            <a  class="mainblock-label">答题卡</a>
          </div>
        </div>
        <div class="container-body panel-party" style="display: flex;flex-direction: column">
          <div class="party-right">
            <div class="dataContent">
              <div v-for="(question,index) in questionList" class="questionItem">
                <div class="questionRow">
                  <div class="type" v-if="question.questionType == 1" style="color: green"> （判断题）</div>
                  <div class="type" v-if="question.questionType == 2" style="color: blue"> （单选题）</div>
                  <div class="type" v-if="question.questionType == 3" style="color: darkblue"> （多选题）</div>
                  <div>{{index+1}}、</div>
                  <div class="questionContent" v-html="question.questionContent"></div>
                </div>

                <div  v-for="answer in question.answerList"
                      class="answerInfo"
                      v-html="answer.optionName+'、' + answer.answerContent"></div>
                <div class="solution" v-html="'正确答案：'+ question.solution"></div>
                <div class="solution" v-html="'你的答案：'+ question.userAnswer"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
  .container-head{
    justify-content: space-between;
  }
  .buttonContainer{
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .submitButton{
    align-self: end;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-right: 2rem;
  }
  .answer-bg{
    margin-top: 10px;
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #9e9e9e solid;
    padding: 5px 5px 5px 15px;
    border-radius: 4px;
    background: #fafafa;
    color: #616161;

  }

  .answer-choose{

    margin-top: 10px;
    margin-left: 20px;
    word-wrap:break-word;
    border: 1px #4caf50 solid;
    padding: 5px 5px 5px 15px;
    border-radius: 4px;
    background: #e8f5e9;
    color: #388E3C;

  }
  .questionContent{
    width: 1000px;
    float:left;
    text-overflow:ellipsis;
    overflow:hidden;
  }
  p{
    text-align: start;
    margin: 0 auto;
    word-wrap:break-word;

  }
  .party-right{
    margin-left: 0px;
  }
  .dataContent{
    height: 650px;
    overflow-y: auto;
  }
  .questionItem{
    display: flex;
    flex-direction: column;
  }
  .questionItem + .questionItem{
    margin-top: 20px;
  }
  .answerInfo {
    margin-top: 10px;
    margin-left: 20px;
    word-wrap:break-word;
  }
  .questionRow{
    display: flex;
  }
  .type{
    min-width: 80px;
  }
  .solution{
    margin-top: 10px;
    margin-left: 20px;
  }
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  const moment = require('moment')
  export default {
    name: 'Training',
    inject:['check'],
    data(){
      return {
        examId:'',
        examInfo: '',
        questionList: [],
        startTime:'',
        testTime: 0,
        testTimeTxt:'',
        examTime: 0,
        auto:{},
        onlineExamUserId: '',
        testStartTime: '',
        testEndTime: ''
      }
    },
    mounted() {
      this.onlineExamUserId = this.$route.query.onlineExamUserId
      this.findAllData()
    },
    methods:{
      findAllData(){
        var params = {
          onlineExamUserId: this.onlineExamUserId
        }
        let url = '/api/onlineExam/findOnlineRecordList'
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
          let size = res.data.length
          let url1 = "/api/onlineExam/findOnlineQuestionList"
          let params1 = {
            answerUUID:res.data[size-1].answerUUId
          }
          console.log(res.data[size-1])
          that.axios.post(url1,params1).then(res1=>{
            viewFunction.handlerRes(that,res1,function () {
                that.questionList = res1.data
            })
          })
        }))
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/ExamResult.vue